import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dataset", "container"]
  // the dataset target element must be inside a container 
  // so that the whole thing including label, etc., can be hidden
  // when there are no results
  selectedItem(event) {
    event.preventDefault();

    var filterIndex = event.target.selectedIndex;
    var filterText = event.target[filterIndex].text;

    for (let i = 0; i < this.datasetTargets.length; i++) {
      var datasetOptions = this.datasetTargets[i].querySelectorAll('optgroup');
      for (let i = 0; i < datasetOptions.length; i++) {
        if (datasetOptions[i].label == filterText) {
          datasetOptions[i].style = 'display: block';
        }
        else {
          datasetOptions[i].style = 'display: none';
        }
      }
    }
  }
}
